import { render } from "./Editar.vue?vue&type=template&id=54b4889b"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__